<template>
    <div v-if="visible" class="video-container">
        <input
            v-if="!video && !processing"
            id="input-file-video"
            type="file"
            @change="addVideo"
            accept=".mp4, .webm, .mov"
        >
        <video v-if="video && video !== 'processing'" :src="videoSrc ? videoSrc : (video && isNaN(video) ? video : '')" controls />
        <div v-if="video && video !== 'processing'" class="video-container-remove" @click="removeVideo">
            <i class="fa fa-times"></i>
        </div>
        <div v-if="!video || video === 'processing'" class="element-button-info">
            <div v-show="!processing && video !== 'processing'" class="element-button-info-text">
                <i class="fa fa-plus"></i>
                <span>{{ $parent.str['add_video'] }}</span>
            </div>
            <div v-if="processing || video === 'processing'" class="element-button-info-processing" v-html="processingText ? processingText : $parent.str['processing']">
            </div>
        </div>
    </div>
</template>
<style scoped>
    .video-container {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 15px;
    }

    .video-container video {
        width: 100%;
        max-height: 300px;
    }

    .video-container input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 99;
        opacity: 0;
    }

    .video-container button svg {
        margin-right: 10px;
    }

    .video-container img {
        max-width: 100%;
    }

    .video-container-remove {
        position: absolute;
        z-index: 99;
        right: 10px;
        top: 10px;
        font-size: 22px;
        cursor: pointer;
    }

    .element-button-info {
        width: 100%;
        max-width: 200px;
        margin: 0 auto;
        height: 100px;
        border: 1px solid #fff;
        border-radius: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;
    }

    .element-button-info-text {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .element-button-info-text svg {
        margin-right: 7px;
    }

    .element-button-info-processing {
        text-align: center;
        padding: 4px;
    }
</style>
<script>
    import Api from '../services/Api'
    import StorageApi from '../services/StorageApi'
    import Utils from '../services/Utils'

    export default {
        name: 'video-element',
        props: ['callback', 'argument', 'video'],
        data() {
            return {
                visible: true,
                processing: null,
                processingText: null,
                videoSrc: null
            }
        },
        watch: {
            video: function () {
                this.setVideo()
            }
        },
        methods: {
            setVideo: function () {
                const self = this
                if (!this.videoSrc && this.video && !isNaN(this.video)) {
                    this.processing = true
                    StorageApi.getFile({
                        id: this.video
                    }, function (response) {
                        if (response.success && response.data && response.data[0]) {
                            self.processing = false
                            self.videoSrc = response.data[0].file
                        }
                    })
                }
            },
            addVideo: function (event) {
                const self = this

                if (!this.$parent.config.upload_video) {
                    return this.$alert(
                        this.$parent.str['no_data'],
                        '',
                        'warning',
                        Utils.getAlertOptions()
                    )
                }

                const file = event.srcElement.files[0]
                this.processing = true
                this.uploadVideo(file, function (result, errorMessage) {
                    self.processing = false
                    if (result) {
                        self.callback(result, self.argument)
                    } else {
                        self.callback(null, self.argument)
                        self.$alert(
                            errorMessage || self.$parent.str['upload_video_error'],
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                    }
                })
            },
            uploadVideo: function (file, callback) {
                const self = this

                if (this.$parent.config.upload_video && this.$parent.config.upload_video.aws) {
                    this.videoSrc = URL.createObjectURL(file)
                    Api.getVideoName({
                        pe_id: this.$parent.physicalEvaluationToSave ? this.$parent.physicalEvaluationToSave.id : null,
                        field: this.argument.item.id
                    }, function (response) {
                        if (response.success) {
                            const split = file.name.split('.')
                            const format = split[split.length - 1]
                            file = new File([file], response.data + '.' + format, {
                                type: file.type,
                            })
                        }
                        StorageApi.uploadFile(file, function (response) {
                            if (response.data && response.data.view_url) {
                                callback(response.data.view_url)
                            } else {
                                callback(false, self.$parent.str['upload_video_size_error'])
                            }
                        })
                    })
                    return
                }

                // Chunk size = 5MB
                const chunkSize = 1024 * 1024 * 5
                const reader = new FileReader()
                this.callback('processing', this.argument)
                this.processingText = '0%'
                reader.readAsDataURL(file)
                reader.onload = function () {
                    if (!reader.result) {
                        callback(false, self.$parent.str['upload_video_size_error'])
                        return
                    }
                    if (self.argument && self.argument.item && self.argument.item.id) {
                        Api.getVideoName({
                            pe_id: self.$parent.physicalEvaluationToSave ? self.$parent.physicalEvaluationToSave.id : null,
                            field: self.argument.item.id
                        }, function (response) {
                            if (response.success) {
                                const split = file.name.split('.')
                                const format = split[split.length - 1]
                                sendVideo(response.data + '.' + format, reader.result)
                            } else {
                                sendVideo(file.name, reader.result)
                            }
                        })
                    } else {
                        sendVideo(file.name, reader.result)
                    }

                    function sendVideo(fileName, fileBase64) {
                        const totalChunks = Math.ceil(fileBase64.length / chunkSize)
                        let currentChunk = 0
                        let videoAlreadyExist = null

                        if (fileName.indexOf('.mov') > -1) {
                            fileName = fileName.replace('.mov', '.mp4')
                            fileBase64 = fileBase64.replace('video/quicktime', 'video/mp4')
                        }

                        sendChunk()

                        function sendChunk() {
                            const chunk = fileBase64.substring(currentChunk * chunkSize, (currentChunk + 1) * chunkSize)
                            StorageApi.sendVideo({
                                file: {
                                    name: self.$parent.config.upload_video.name + fileName,
                                    type: 0,
                                    file: chunk
                                },
                                base64: self.$parent.config.upload_video.base64,
                                compressed: self.$parent.config.upload_video.compressed,
                                chunkIndex: currentChunk,
                                totalChunks: totalChunks,
                                fileToUpdate: videoAlreadyExist
                            }, function (response) {
                                if (response.success) {
                                    videoAlreadyExist = response.extraData
                                    currentChunk++
                                    self.processingText = currentChunk === (totalChunks - 1) ? self.$parent.str['processing_video'] : (Math.round(currentChunk / totalChunks * 100) + '%')
                                    if (currentChunk < totalChunks) {
                                        sendChunk()
                                    } else {
                                        self.videoSrc = response.data.file ? response.data.file : fileBase64
                                        callback(response.data.id.toString())
                                    }
                                } else {
                                    callback(false)
                                }
                            })
                        }
                    }
                }
                reader.onerror = function () {
                    callback(false)
                }
            },
            removeVideo: function () {
                const self = this
                this.callback(null, this.argument)
                this.visible = false
                setTimeout(function () {
                    self.visible = true
                })
            },
        },
    }
</script>